import { Checkbox } from "primereact/checkbox";
import React from "react";
import "./style.scss";

const CheckboxUI = ({ addClass = "", label = "", onChange = () => {}, disabled = false, value = "", dataId = [] }) => {
    return (
        <div className={"detail__item checkbox" + addClass}>
            <div className={"checkbox__container " + addClass}>
                <Checkbox disabled={disabled} onChange={onChange} checked={value == "true" || value == true ? true : false} data-id={dataId.join(".")} />
                <label>{label}</label>
            </div>
        </div>
    );
};

export default CheckboxUI;
